import Swiper from "swiper";

export const sliderHomeAvis = (slider: HTMLElement) => {
    new Swiper(slider, {
        // Configs
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,

        breakpoints: {
            500: {
                slidesPerView: 1.5,
            }
        }
    })
}
